export default "__VITE_ASSET__DCAFsBnZ__"